import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/construct-x/shared/shared.module';
import { DidGeneratorComponent } from './components/did-generator/did-generator.component';
import { DidWebGeneratorComponent } from './components/did-web-generator/did-web-generator.component';
import { HttpClientModule } from "@angular/common/http";
import { provideTranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from "src/app/construct-x/shared/services/language.service";

/**
 * Module that exports only the DID generator components (create DID UI).
 * Use this when you need to embed DID creation without the did-manager routes.
 */
@NgModule({
  imports: [
    DidGeneratorComponent,
    DidWebGeneratorComponent,
    SharedModule,
    HttpClientModule,
    TranslateModule.forRoot(),
  ],
  exports: [
    DidGeneratorComponent,
    DidWebGeneratorComponent,
    SharedModule
  ],
  providers: [
    ...provideTranslateHttpLoader({ prefix: './assets/i18n/', suffix: '.json' }),
    LanguageService
  ]
})
export class DidGeneratorModule {}
